import { Modal, Button, Form, ModalBody, ModalFooter } from "react-bootstrap";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import { useState } from "react";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;
axios.defaults.withCredentials = true;

const ForgotPasswordModal = ({ show, handleClose }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState("");
  const [validated, setValidated] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess("");

    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post("/user/forgot-password", { email });
      setSuccess(response.data.message);
    } catch (err) {
      setError(err.response?.data?.message || "An error occurred");
    } finally {
      setLoading(false);
    }
  };

  const handleCloseModal = () => {
    //delay state reset until after modal is closed
    setTimeout(() => {
      resetState();
    }, 300);
    handleClose();
  };

  const resetState = () => {
    setEmail("");
    setError(null);
    setSuccess("");
    setValidated(false);
  };

  return (
    <Modal show={show} onHide={handleCloseModal} centered>
      <Form noValidate validated={validated} onSubmit={handleSubmit}>
        <ModalBody className='p-4'>
          <h5>Forgot Password?</h5>
          {error && <div className='alert alert-danger'>{error}</div>}
          {success && <div className='alert alert-success'>{success}</div>}
          <h6 className='text-secondary'>
            Please enter the email associated with your account.
          </h6>
          <Form.Group controlId='formBasicEmail' className='mt-3'>
            <FloatingLabel label='Email address'>
              <Form.Control
                type='email'
                placeholder='Enter your email'
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={loading || success !== ""}
              />
              <Form.Control.Feedback type='invalid'>
                Please provide a valid email address.
              </Form.Control.Feedback>
            </FloatingLabel>
          </Form.Group>
          <p className='text-secondary mt-2 mb-0'>
            <small>
              If you need further assistance, please contact{" "}
              <a href='mailto:reachback@spectraplasmonics.com'>
                reachback@spectraplasmonics.com
              </a>
              .
            </small>
          </p>
        </ModalBody>
        <ModalFooter className='p-4'>
          <Button variant='secondary' onClick={handleCloseModal}>
            Close
          </Button>
          {(success === "" || loading === true) && (
            <Button variant='primary' type='submit' disabled={loading}>
              {loading ? "Loading..." : "Submit"}
            </Button>
          )}
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default ForgotPasswordModal;
